var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _path37, _g2, _path38, _g3, _path39, _g4, _path40, _g5, _path41, _g6, _path42, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrCode = function SvgQrCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qr-code_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0v128h128V0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "qr-code_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 112,
    height: 112
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.16 42.88H8.32v3.84h3.84v-3.84ZM12.16 46.72H8.32v3.84h3.84v-3.84ZM12.16 58.24H8.32v3.84h3.84v-3.84ZM12.16 65.92H8.32v3.84h3.84v-3.84ZM12.16 69.76H8.32v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.16 73.6H8.32v3.84h3.84V73.6ZM12.16 77.44H8.32v3.84h3.84v-3.84ZM12.16 81.28H8.32v3.84h3.84v-3.84ZM12.16 85.12H8.32v3.84h3.84v-3.84ZM16 39.04h-3.84v3.84H16v-3.84ZM16 50.56h-3.84v3.84H16v-3.84ZM16 65.92h-3.84v3.84H16v-3.84ZM16 69.76h-3.84v3.84H16v-3.84Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 73.6h-3.84v3.84H16V73.6ZM16 77.44h-3.84v3.84H16v-3.84ZM16 81.28h-3.84v3.84H16v-3.84ZM19.84 46.72H16v3.84h3.84v-3.84ZM19.84 50.56H16v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.84 54.4H16v3.84h3.84V54.4ZM19.84 58.24H16v3.84h3.84v-3.84ZM19.84 77.44H16v3.84h3.84v-3.84ZM19.84 81.28H16v3.84h3.84v-3.84ZM19.84 85.12H16v3.84h3.84v-3.84ZM23.68 39.04h-3.84v3.84h3.84v-3.84ZM23.68 42.88h-3.84v3.84h3.84v-3.84ZM23.68 54.4h-3.84v3.84h3.84V54.4ZM23.68 65.92h-3.84v3.84h3.84v-3.84ZM23.68 73.6h-3.84v3.84h3.84V73.6ZM23.68 81.28h-3.84v3.84h3.84v-3.84ZM27.52 39.04h-3.84v3.84h3.84v-3.84ZM27.52 50.56h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.52 54.4h-3.84v3.84h3.84V54.4ZM27.52 58.24h-3.84v3.84h3.84v-3.84ZM27.52 65.92h-3.84v3.84h3.84v-3.84ZM27.52 81.28h-3.84v3.84h3.84v-3.84ZM31.36 46.72h-3.84v3.84h3.84v-3.84ZM31.36 62.08h-3.84v3.84h3.84v-3.84ZM31.36 65.92h-3.84v3.84h3.84v-3.84ZM31.36 85.12h-3.84v3.84h3.84v-3.84ZM35.2 39.04h-3.84v3.84h3.84v-3.84ZM35.2 46.72h-3.84v3.84h3.84v-3.84ZM35.2 54.4h-3.84v3.84h3.84V54.4ZM35.2 62.08h-3.84v3.84h3.84v-3.84ZM35.2 69.76h-3.84v3.84h3.84v-3.84ZM35.2 77.44h-3.84v3.84h3.84v-3.84ZM35.2 85.12h-3.84v3.84h3.84v-3.84ZM39.04 39.04H35.2v3.84h3.84v-3.84ZM39.04 58.24H35.2v3.84h3.84v-3.84ZM39.04 62.08H35.2v3.84h3.84v-3.84ZM39.04 69.76H35.2v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.04 73.6H35.2v3.84h3.84V73.6ZM39.04 77.44H35.2v3.84h3.84v-3.84ZM42.88 12.16h-3.84V16h3.84v-3.84ZM42.88 19.84h-3.84v3.84h3.84v-3.84ZM42.88 23.68h-3.84v3.84h3.84v-3.84ZM42.88 27.52h-3.84v3.84h3.84v-3.84ZM42.88 31.36h-3.84v3.84h3.84v-3.84ZM42.88 39.04h-3.84v3.84h3.84v-3.84ZM42.88 42.88h-3.84v3.84h3.84v-3.84ZM42.88 54.4h-3.84v3.84h3.84V54.4ZM42.88 65.92h-3.84v3.84h3.84v-3.84ZM42.88 69.76h-3.84v3.84h3.84v-3.84ZM42.88 88.96h-3.84v3.84h3.84v-3.84ZM42.88 92.8h-3.84v3.84h3.84V92.8ZM42.88 100.48h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.88 104.32h-3.84v3.84h3.84v-3.84ZM42.88 112h-3.84v3.84h3.84V112ZM46.72 12.16h-3.84V16h3.84v-3.84ZM46.72 19.84h-3.84v3.84h3.84v-3.84ZM46.72 23.68h-3.84v3.84h3.84v-3.84ZM46.72 46.72h-3.84v3.84h3.84v-3.84ZM46.72 50.56h-3.84v3.84h3.84v-3.84ZM46.72 62.08h-3.84v3.84h3.84v-3.84ZM46.72 69.76h-3.84v3.84h3.84v-3.84ZM46.72 77.44h-3.84v3.84h3.84v-3.84ZM46.72 81.28h-3.84v3.84h3.84v-3.84ZM46.72 96.64h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.72 100.48h-3.84v3.84h3.84v-3.84ZM46.72 108.16h-3.84V112h3.84v-3.84ZM46.72 112h-3.84v3.84h3.84V112ZM50.56 8.32h-3.84v3.84h3.84V8.32ZM50.56 16h-3.84v3.84h3.84V16ZM50.56 19.84h-3.84v3.84h3.84v-3.84ZM50.56 23.68h-3.84v3.84h3.84v-3.84ZM50.56 27.52h-3.84v3.84h3.84v-3.84ZM50.56 31.36h-3.84v3.84h3.84v-3.84ZM50.56 35.2h-3.84v3.84h3.84V35.2Z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.56 39.04h-3.84v3.84h3.84v-3.84ZM50.56 46.72h-3.84v3.84h3.84v-3.84ZM50.56 50.56h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.56 54.4h-3.84v3.84h3.84V54.4ZM50.56 58.24h-3.84v3.84h3.84v-3.84ZM50.56 65.92h-3.84v3.84h3.84v-3.84ZM50.56 69.76h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.56 73.6h-3.84v3.84h3.84V73.6ZM50.56 88.96h-3.84v3.84h3.84v-3.84ZM50.56 92.8h-3.84v3.84h3.84V92.8ZM50.56 100.48h-3.84v3.84h3.84v-3.84ZM54.4 8.32h-3.84v3.84h3.84V8.32ZM54.4 12.16h-3.84V16h3.84v-3.84ZM54.4 16h-3.84v3.84h3.84V16ZM54.4 27.52h-3.84v3.84h3.84v-3.84ZM54.4 35.2h-3.84v3.84h3.84V35.2Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 39.04h-3.84v3.84h3.84v-3.84ZM54.4 46.72h-3.84v3.84h3.84v-3.84ZM54.4 50.56h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 54.4h-3.84v3.84h3.84V54.4ZM54.4 58.24h-3.84v3.84h3.84v-3.84ZM54.4 62.08h-3.84v3.84h3.84v-3.84ZM54.4 65.92h-3.84v3.84h3.84v-3.84ZM54.4 73.6h-3.84v3.84h3.84V73.6ZM54.4 77.44h-3.84v3.84h3.84v-3.84ZM54.4 81.28h-3.84v3.84h3.84v-3.84ZM54.4 85.12h-3.84v3.84h3.84v-3.84ZM54.4 104.32h-3.84v3.84h3.84v-3.84ZM54.4 115.84h-3.84v3.84h3.84v-3.84ZM58.24 12.16H54.4V16h3.84v-3.84ZM58.24 16H54.4v3.84h3.84V16ZM58.24 19.84H54.4v3.84h3.84v-3.84ZM58.24 23.68H54.4v3.84h3.84v-3.84ZM58.24 31.36H54.4v3.84h3.84v-3.84ZM58.24 39.04H54.4v3.84h3.84v-3.84ZM58.24 46.72H54.4v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.24 50.56H54.4v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.24 54.4H54.4v3.84h3.84V54.4ZM58.24 58.24H54.4v3.84h3.84v-3.84ZM58.24 62.08H54.4v3.84h3.84v-3.84ZM58.24 85.12H54.4v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.24 88.96H54.4v3.84h3.84v-3.84ZM58.24 92.8H54.4v3.84h3.84V92.8ZM58.24 104.32H54.4v3.84h3.84v-3.84ZM58.24 112H54.4v3.84h3.84V112ZM62.08 12.16h-3.84V16h3.84v-3.84ZM62.08 19.84h-3.84v3.84h3.84v-3.84ZM62.08 27.52h-3.84v3.84h3.84v-3.84ZM62.08 35.2h-3.84v3.84h3.84V35.2ZM62.08 42.88h-3.84v3.84h3.84v-3.84ZM62.08 58.24h-3.84v3.84h3.84v-3.84ZM62.08 62.08h-3.84v3.84h3.84v-3.84ZM62.08 69.76h-3.84v3.84h3.84v-3.84ZM62.08 77.44h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.08 92.8h-3.84v3.84h3.84V92.8ZM62.08 100.48h-3.84v3.84h3.84v-3.84ZM62.08 108.16h-3.84V112h3.84v-3.84ZM62.08 112h-3.84v3.84h3.84V112ZM62.08 115.84h-3.84v3.84h3.84v-3.84ZM65.92 16h-3.84v3.84h3.84V16ZM65.92 19.84h-3.84v3.84h3.84v-3.84ZM65.92 23.68h-3.84v3.84h3.84v-3.84ZM65.92 27.52h-3.84v3.84h3.84v-3.84ZM65.92 31.36h-3.84v3.84h3.84v-3.84ZM65.92 35.2h-3.84v3.84h3.84V35.2ZM65.92 42.88h-3.84v3.84h3.84v-3.84ZM65.92 46.72h-3.84v3.84h3.84v-3.84ZM65.92 54.4h-3.84v3.84h3.84V54.4ZM65.92 62.08h-3.84v3.84h3.84v-3.84ZM65.92 77.44h-3.84v3.84h3.84v-3.84ZM65.92 81.28h-3.84v3.84h3.84v-3.84ZM65.92 92.8h-3.84v3.84h3.84V92.8ZM65.92 96.64h-3.84v3.84h3.84v-3.84ZM65.92 104.32h-3.84v3.84h3.84v-3.84ZM65.92 115.84h-3.84v3.84h3.84v-3.84ZM69.76 8.32h-3.84v3.84h3.84V8.32ZM69.76 16h-3.84v3.84h3.84V16ZM69.76 23.68h-3.84v3.84h3.84v-3.84ZM69.76 27.52h-3.84v3.84h3.84v-3.84ZM69.76 39.04h-3.84v3.84h3.84v-3.84ZM69.76 54.4h-3.84v3.84h3.84V54.4ZM69.76 62.08h-3.84v3.84h3.84v-3.84ZM69.76 65.92h-3.84v3.84h3.84v-3.84ZM69.76 69.76h-3.84v3.84h3.84v-3.84ZM69.76 85.12h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.76 88.96h-3.84v3.84h3.84v-3.84ZM69.76 92.8h-3.84v3.84h3.84V92.8ZM69.76 100.48h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.76 104.32h-3.84v3.84h3.84v-3.84ZM69.76 108.16h-3.84V112h3.84v-3.84ZM69.76 112h-3.84v3.84h3.84V112ZM69.76 115.84h-3.84v3.84h3.84v-3.84ZM73.6 8.32h-3.84v3.84h3.84V8.32ZM73.6 12.16h-3.84V16h3.84v-3.84ZM73.6 23.68h-3.84v3.84h3.84v-3.84ZM73.6 31.36h-3.84v3.84h3.84v-3.84ZM73.6 42.88h-3.84v3.84h3.84v-3.84ZM73.6 50.56h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6 54.4h-3.84v3.84h3.84V54.4ZM73.6 58.24h-3.84v3.84h3.84v-3.84ZM73.6 62.08h-3.84v3.84h3.84v-3.84ZM73.6 73.6h-3.84v3.84h3.84V73.6ZM73.6 77.44h-3.84v3.84h3.84v-3.84ZM73.6 85.12h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6 88.96h-3.84v3.84h3.84v-3.84ZM73.6 96.64h-3.84v3.84h3.84v-3.84ZM73.6 104.32h-3.84v3.84h3.84v-3.84ZM77.44 8.32H73.6v3.84h3.84V8.32ZM77.44 12.16H73.6V16h3.84v-3.84ZM77.44 23.68H73.6v3.84h3.84v-3.84ZM77.44 39.04H73.6v3.84h3.84v-3.84ZM77.44 46.72H73.6v3.84h3.84v-3.84ZM77.44 50.56H73.6v3.84h3.84v-3.84ZM77.44 58.24H73.6v3.84h3.84v-3.84ZM77.44 73.6H73.6v3.84h3.84V73.6ZM77.44 81.28H73.6v3.84h3.84v-3.84ZM77.44 85.12H73.6v3.84h3.84v-3.84ZM77.44 100.48H73.6v3.84h3.84v-3.84ZM77.44 108.16H73.6V112h3.84v-3.84ZM81.28 8.32h-3.84v3.84h3.84V8.32ZM81.28 12.16h-3.84V16h3.84v-3.84ZM81.28 16h-3.84v3.84h3.84V16ZM81.28 19.84h-3.84v3.84h3.84v-3.84ZM81.28 27.52h-3.84v3.84h3.84v-3.84ZM81.28 31.36h-3.84v3.84h3.84v-3.84ZM81.28 35.2h-3.84v3.84h3.84V35.2ZM81.28 54.4h-3.84v3.84h3.84V54.4ZM81.28 69.76h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.28 73.6h-3.84v3.84h3.84V73.6ZM81.28 77.44h-3.84v3.84h3.84v-3.84ZM81.28 81.28h-3.84v3.84h3.84v-3.84ZM81.28 100.48h-3.84v3.84h3.84v-3.84ZM81.28 108.16h-3.84V112h3.84v-3.84ZM81.28 115.84h-3.84v3.84h3.84v-3.84ZM85.12 8.32h-3.84v3.84h3.84V8.32ZM85.12 12.16h-3.84V16h3.84v-3.84ZM85.12 23.68h-3.84v3.84h3.84v-3.84ZM85.12 27.52h-3.84v3.84h3.84v-3.84ZM85.12 35.2h-3.84v3.84h3.84V35.2Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.12 39.04h-3.84v3.84h3.84v-3.84ZM85.12 50.56h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.12 54.4h-3.84v3.84h3.84V54.4ZM85.12 65.92h-3.84v3.84h3.84v-3.84ZM85.12 69.76h-3.84v3.84h3.84v-3.84ZM85.12 85.12h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85.12 88.96h-3.84v3.84h3.84v-3.84ZM85.12 92.8h-3.84v3.84h3.84V92.8ZM85.12 108.16h-3.84V112h3.84v-3.84ZM85.12 112h-3.84v3.84h3.84V112ZM85.12 115.84h-3.84v3.84h3.84v-3.84ZM88.96 8.32h-3.84v3.84h3.84V8.32ZM88.96 12.16h-3.84V16h3.84v-3.84ZM88.96 16h-3.84v3.84h3.84V16ZM88.96 27.52h-3.84v3.84h3.84v-3.84ZM88.96 31.36h-3.84v3.84h3.84v-3.84ZM88.96 35.2h-3.84v3.84h3.84V35.2Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.96 39.04h-3.84v3.84h3.84v-3.84ZM88.96 46.72h-3.84v3.84h3.84v-3.84ZM88.96 62.08h-3.84v3.84h3.84v-3.84ZM88.96 73.6h-3.84v3.84h3.84V73.6ZM88.96 81.28h-3.84v3.84h3.84v-3.84ZM88.96 85.12h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.96 88.96h-3.84v3.84h3.84v-3.84ZM88.96 92.8h-3.84v3.84h3.84V92.8ZM88.96 96.64h-3.84v3.84h3.84v-3.84ZM88.96 100.48h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M88.96 104.32h-3.84v3.84h3.84v-3.84ZM88.96 108.16h-3.84V112h3.84v-3.84ZM88.96 112h-3.84v3.84h3.84V112ZM92.8 39.04h-3.84v3.84h3.84v-3.84ZM92.8 42.88h-3.84v3.84h3.84v-3.84ZM92.8 46.72h-3.84v3.84h3.84v-3.84ZM92.8 54.4h-3.84v3.84h3.84V54.4ZM92.8 58.24h-3.84v3.84h3.84v-3.84ZM92.8 62.08h-3.84v3.84h3.84v-3.84ZM92.8 65.92h-3.84v3.84h3.84v-3.84ZM92.8 73.6h-3.84v3.84h3.84V73.6ZM92.8 77.44h-3.84v3.84h3.84v-3.84ZM92.8 81.28h-3.84v3.84h3.84v-3.84ZM92.8 85.12h-3.84v3.84h3.84v-3.84ZM92.8 100.48h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8 104.32h-3.84v3.84h3.84v-3.84ZM92.8 108.16h-3.84V112h3.84v-3.84ZM96.64 42.88H92.8v3.84h3.84v-3.84ZM96.64 46.72H92.8v3.84h3.84v-3.84ZM96.64 50.56H92.8v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.64 54.4H92.8v3.84h3.84V54.4ZM96.64 65.92H92.8v3.84h3.84v-3.84ZM96.64 81.28H92.8v3.84h3.84v-3.84ZM96.64 85.12H92.8v3.84h3.84v-3.84ZM96.64 92.8H92.8v3.84h3.84V92.8ZM96.64 100.48H92.8v3.84h3.84v-3.84ZM96.64 108.16H92.8V112h3.84v-3.84ZM100.481 39.04h-3.84v3.84h3.84v-3.84ZM100.481 42.88h-3.84v3.84h3.84v-3.84ZM100.481 58.24h-3.84v3.84h3.84v-3.84ZM100.481 65.92h-3.84v3.84h3.84v-3.84ZM100.481 77.44h-3.84v3.84h3.84v-3.84ZM100.481 81.28h-3.84v3.84h3.84v-3.84ZM100.481 85.12h-3.84v3.84h3.84v-3.84ZM100.481 100.48h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M100.481 104.32h-3.84v3.84h3.84v-3.84ZM104.32 39.04h-3.84v3.84h3.84v-3.84ZM104.32 46.72h-3.84v3.84h3.84v-3.84ZM104.32 50.56h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.32 54.4h-3.84v3.84h3.84V54.4ZM104.32 58.24h-3.84v3.84h3.84v-3.84ZM104.32 62.08h-3.84v3.84h3.84v-3.84ZM104.32 73.6h-3.84v3.84h3.84V73.6ZM104.32 81.28h-3.84v3.84h3.84v-3.84ZM104.32 85.12h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.32 88.96h-3.84v3.84h3.84v-3.84ZM104.32 92.8h-3.84v3.84h3.84V92.8ZM104.32 96.64h-3.84v3.84h3.84v-3.84ZM104.32 100.48h-3.84v3.84h3.84v-3.84ZM104.32 115.84h-3.84v3.84h3.84v-3.84ZM108.16 39.04h-3.84v3.84h3.84v-3.84ZM108.16 42.88h-3.84v3.84h3.84v-3.84ZM108.16 54.4h-3.84v3.84h3.84V54.4ZM108.16 73.6h-3.84v3.84h3.84V73.6ZM108.16 77.44h-3.84v3.84h3.84v-3.84ZM108.16 96.64h-3.84v3.84h3.84v-3.84ZM108.16 108.16h-3.84V112h3.84v-3.84ZM108.16 112h-3.84v3.84h3.84V112ZM112 42.88h-3.84v3.84H112v-3.84ZM112 50.56h-3.84v3.84H112v-3.84ZM112 65.92h-3.84v3.84H112v-3.84ZM112 85.12h-3.84v3.84H112v-3.84Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M112 88.96h-3.84v3.84H112v-3.84ZM112 96.64h-3.84v3.84H112v-3.84ZM112 100.48h-3.84v3.84H112v-3.84Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M112 104.32h-3.84v3.84H112v-3.84ZM112 108.16h-3.84V112H112v-3.84ZM112 112h-3.84v3.84H112V112ZM112 115.84h-3.84v3.84H112v-3.84ZM115.84 39.04H112v3.84h3.84v-3.84ZM115.84 46.72H112v3.84h3.84v-3.84ZM115.84 54.4H112v3.84h3.84V54.4ZM115.84 58.24H112v3.84h3.84v-3.84ZM115.84 69.76H112v3.84h3.84v-3.84ZM115.84 77.44H112v3.84h3.84v-3.84ZM115.84 88.96H112v3.84h3.84v-3.84ZM115.84 100.48H112v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M115.84 104.32H112v3.84h3.84v-3.84ZM115.84 108.16H112V112h3.84v-3.84ZM115.84 115.84H112v3.84h3.84v-3.84ZM119.68 42.88h-3.84v3.84h3.84v-3.84ZM119.68 46.72h-3.84v3.84h3.84v-3.84ZM119.68 58.24h-3.84v3.84h3.84v-3.84ZM119.68 62.08h-3.84v3.84h3.84v-3.84ZM119.68 65.92h-3.84v3.84h3.84v-3.84ZM119.68 77.44h-3.84v3.84h3.84v-3.84ZM119.68 81.28h-3.84v3.84h3.84v-3.84ZM119.68 85.12h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M119.68 88.96h-3.84v3.84h3.84v-3.84ZM119.68 92.8h-3.84v3.84h3.84V92.8ZM119.68 96.64h-3.84v3.84h3.84v-3.84ZM119.68 100.48h-3.84v3.84h3.84v-3.84Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#qr-code_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0v128h128V0Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "qr-code_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 28,
    height: 28
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32 8.32V35.2H35.2V8.32H8.32Zm3.84 3.84h19.2v19.2h-19.2v-19.2Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#qr-code_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2 8.32H8.32V35.2H35.2V8.32Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "qr-code_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 12,
    height: 12
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.52 16H16v11.52h11.52V16Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#qr-code_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.52 16H16v11.52h11.52V16Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "qr-code_svg__e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 8,
    width: 28,
    height: 28
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.68 8.32H92.8V35.2h26.88V8.32Zm-3.84 3.84v19.2h-19.2v-19.2h19.2Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#qr-code_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.68 8.32H92.8V35.2h26.88V8.32Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "qr-code_svg__f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 16,
    width: 12,
    height: 12
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112 27.52V16h-11.52v11.52H112Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#qr-code_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 16h-11.52v11.52H112V16Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "qr-code_svg__g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 92,
    width: 28,
    height: 28
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32 119.68H35.2V92.8H8.32v26.88Zm3.84-3.84v-19.2h19.2v19.2h-19.2Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#qr-code_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2 92.8H8.32v26.88H35.2V92.8Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "qr-code_svg__h",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 100,
    width: 12,
    height: 12
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16 100.48V112h11.52v-11.52H16Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#qr-code_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.52 100.48H16V112h11.52v-11.52Z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qr-code_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h128v128H0z"
  })))));
};
export default SvgQrCode;